<template>
    <div class="explorer-window">
        <!-- Windows 7 style toolbar -->
        <div class="toolbar">
            <div class="toolbar-content">
                <div class="breadcrumb">
                    <span class="breadcrumb-item clickable" @click="goHome">Ce PC</span>
                    <span class="breadcrumb-separator">›</span>
                    <span class="breadcrumb-item current">Idées Brillantes</span>
                </div>
                <button class="close-button" @click="goHome" title="Fermer">
                    <span class="close-icon">×</span>
                </button>
            </div>
        </div>

        <!-- File explorer content area -->
        <div class="explorer-content">
            <div class="files-grid">
                <!-- Project files -->
                <div v-for="file in files" :key="file.name" class="file-item" @click="openFile(file)">
                    <div class="file-icon">
                        <img :src="file.icon" :alt="file.name" />
                    </div>
                    <div class="file-name">{{ file.name }}</div>
                </div>
            </div>
        </div>

        <!-- Status bar -->
        <div class="status-bar">
            <span>{{ files.length }} éléments</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProjectsPage',
    data() {
        return {
            files: [
                {
                    name: 'Angine_De_Poitrine.txt',
                    icon: 'assets/icons/file-txt.svg',
                    url: 'https://anginepoitrine.10-4.app/',
                    external: true
                },
                {
                    name: 'SMS.png',
                    icon: 'assets/icons/file-png.svg',
                    url: 'https://sadmazdasongs.com/',
                    external: true
                },
                {
                    name: 'Discord_Bot.draft',
                    icon: 'assets/icons/file-draft.svg',
                    url: '/bot',
                    external: false
                }
            ]
        };
    },
    methods: {
        openFile(file) {
            if (file.external) {
                window.open(file.url, '_blank');
            } else {
                this.$router.push(file.url);
            }
        },
        goHome() {
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>
.explorer-window {
    min-height: calc(100vh - var(--header-height));
    background: #ffffff;
    display: flex;
    flex-direction: column;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    color: #000000;
}

.toolbar {
    background: linear-gradient(to bottom, #f5f6f7 0%, #e8eaed 100%);
    border-bottom: 1px solid #c2c7cc;
    padding: 8px 12px;
    box-shadow: inset 0 1px 0 #ffffff;
}

.toolbar-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.breadcrumb {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #000000;
    padding: 4px 8px;
    background: #ffffff;
    border: 1px solid #abadb3;
    border-radius: 2px;
    max-width: fit-content;
}

.breadcrumb-item {
    padding: 2px 6px;
    cursor: default;
}

.breadcrumb-item.clickable {
    cursor: pointer;
    transition: background-color 0.1s ease;
}

.breadcrumb-item.clickable:hover {
    background-color: rgba(0, 120, 215, 0.1);
    color: #0078d7;
    border-radius: 2px;
}

.breadcrumb-item.current {
    font-weight: 600;
}

.breadcrumb-separator {
    color: #666666;
    padding: 0 4px;
    font-size: 14px;
}

.close-button {
    min-width: 26px;
    height: 22px;
    padding: 0 8px;
    border: 1px solid #abadb3;
    background: linear-gradient(to bottom, #fbfbfb 0%, #ebebeb 100%);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.1s ease;
    border-radius: 0;
}

.close-button:hover {
    background: linear-gradient(to bottom, #fce4e4 0%, #f5b5b8 50%, #e4949a 100%);
    border-color: #9c2a2e;
}

.close-icon {
    font-size: 16px;
    font-weight: 400;
    line-height: 1;
    color: #1a1a1a;
    font-family: 'Segoe UI', Tahoma, sans-serif;
    user-select: none;
}

.close-button:hover .close-icon {
    color: #1a1a1a;
}

.close-button:active {
    background: linear-gradient(to bottom, #d8686d 0%, #d85156 100%);
    border-color: #8c1619;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* Windows 7 blue selection for explorer */
.explorer-window ::-moz-selection {
    background-color: #0078d7;
    color: #fff;
}

.explorer-window ::selection {
    background-color: #0078d7;
    color: #fff;
}

.explorer-content {
    flex: 1;
    background: #ffffff;
    padding: 20px;
    overflow-y: auto;
}

.files-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 30px;
    padding: 10px;
}

.file-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    padding: 12px;
    border-radius: 2px;
    transition: background-color 0.1s ease;
    max-width: 140px;
    margin: 0 auto;
}

.file-item:hover {
    background-color: #e5f3ff;
    outline: 1px solid #99d1ff;
}

.file-item:active {
    background-color: #cce8ff;
}

.file-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.file-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.1));
}

.file-name {
    font-size: 12px;
    text-align: center;
    word-wrap: break-word;
    color: #000000;
    line-height: 1.3;
    max-width: 100%;
}

.file-item:hover .file-name {
    text-decoration: underline;
}

.status-bar {
    background: linear-gradient(to bottom, #f5f6f7 0%, #e1e4e8 100%);
    border-top: 1px solid #c2c7cc;
    padding: 4px 12px;
    font-size: 11px;
    color: #464646;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .explorer-content {
        padding: 12px;
    }

    .files-grid {
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
        gap: 20px;
        padding: 5px;
    }

    .file-item {
        max-width: 120px;
    }

    .breadcrumb {
        font-size: 12px;
        padding: 3px 6px;
    }

    .breadcrumb-item {
        padding: 2px 4px;
    }

    .toolbar {
        padding: 6px 8px;
    }

    .close-button {
        min-width: 24px;
        height: 20px;
        padding: 0 6px;
    }
}

@media (max-width: 480px) {
    .files-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
    }

    .breadcrumb {
        font-size: 11px;
        max-width: calc(100vw - 100px);
    }

    .breadcrumb-item,
    .breadcrumb-separator {
        white-space: nowrap;
    }
}
</style>
